import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardIndentIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.5 2H1.5C1.22386 2 1 2.22386 1 2.5V3.5C1 3.77614 1.22386 4 1.5 4H23.5C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2Z"
        fill={color}
      />
      <path
        d="M23.5 20H1.5C1.22386 20 1 20.2239 1 20.5V21.5C1 21.7761 1.22386 22 1.5 22H23.5C23.7761 22 24 21.7761 24 21.5V20.5C24 20.2239 23.7761 20 23.5 20Z"
        fill={color}
      />
      <path
        d="M23.5 8H12.5C12.2239 8 12 8.22386 12 8.5V9.5C12 9.77614 12.2239 10 12.5 10H23.5C23.7761 10 24 9.77614 24 9.5V8.5C24 8.22386 23.7761 8 23.5 8Z"
        fill={color}
      />
      <path
        d="M23.5 14H12.5C12.2239 14 12 14.2239 12 14.5V15.5C12 15.7761 12.2239 16 12.5 16H23.5C23.7761 16 24 15.7761 24 15.5V14.5C24 14.2239 23.7761 14 23.5 14Z"
        fill={color}
      />
      <path
        d="M4.83 13V15.06C4.83 15.45 5.3 15.64 5.57 15.37L8.43 12.51C8.71 12.23 8.71 11.77 8.43 11.48L5.57 8.61999C5.29 8.33999 4.83 8.53999 4.83 8.92999V10.99H1C0.45 10.99 0 11.44 0 11.99C0 12.54 0.45 12.99 1 12.99H4.83V13Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardIndentIcon.displayName = 'BoardIndentIcon';
